import { useMemo } from "react";
import {
  TableColumnInputType,
  TableColumns,
  TableRow,
} from "src/requests/table/types";
import { StringIndexedDictionary } from "../../../../../globalTypes";

// eslint-disable-next-line import/prefer-default-export
export const sortCellKeysByColumnOrder = (
  cellsKeys: string[],
  columnOrderByColumnName: StringIndexedDictionary<number>
): string[] => {
  cellsKeys.sort((cellKey1, cellKey2) => {
    const order1 = columnOrderByColumnName[cellKey1];
    const order2 = columnOrderByColumnName[cellKey2];
    return (
      (order1 > -1 ? order1 : Infinity) - (order2 > -1 ? order2 : Infinity)
    );
  });

  return cellsKeys;
};

const isColumnTypeFile = (
  colKey: string,
  tableColumns: TableColumns
): boolean => {
  const column = tableColumns[colKey];

  if (!column) return false;

  const { inputType } = column;

  return (
    inputType === TableColumnInputType.File ||
    inputType === TableColumnInputType.HegFile
  );
};

const getDoesRowContainFiles = (
  tableColumns: TableColumns,
  tableRow: TableRow | null
): boolean => {
  if (!tableRow) return false;

  return Object.keys(tableRow.cells).some((colKey) =>
    isColumnTypeFile(colKey, tableColumns)
  );
};

export const useDoesRowContainFiles = (
  tableColumns: TableColumns,
  tableRow: TableRow | null
): boolean =>
  useMemo(
    () => getDoesRowContainFiles(tableColumns, tableRow),
    [tableColumns, tableRow]
  );
